<template>
  <b-card-group>
    <b-card no-body>
      <b-collapse visible>
        <div class="card-body">
          <div>
            <b-form class="filter-form">
              <b-row>
                <b-col cols="1">
                  <b-button v-on:click="reset" size="sm" variant="secondary" class="ml-2">
                    <font-awesome-icon icon="times" />
                    {{ $t('Сброс') }}
                  </b-button>
                </b-col>
                <filter-input
                  :label="$t('ФИО')"
                  v-model="form.name"
                  v-on:onBlur="search"
                ></filter-input>
                <filter-select
                  :label="$t('Организация')"
                  :disabled="!$auth.user().isRdkm || ($auth.user().functions.find(t => t.routeName === 'ExternalUsers') == null)"
                  v-model="form.organizationId"
                  :options="organizations"
                  v-on:onChange="search"
                ></filter-select>
                <filter-input
                  label="E-Mail"
                  v-model="form.email"
                  v-on:onBlur="search"
                ></filter-input>
                <filter-checkbox
                  :label="$t('Пользователи')"
                  id="IsUser"
                  v-model="form.isUser"
                  v-on:onChange="changeIsUser"
                ></filter-checkbox>
                <filter-checkbox
                  :label="$t('Уволенные')"
                  v-model="form.isDeleted"
                  v-on:onChange="changeIsDeleted"
                ></filter-checkbox>
              </b-row>
            </b-form>
          </div>
        </div>
      </b-collapse>
    </b-card>
  </b-card-group>
</template>

<script>
import axios from 'axios';
import BaseFilter from '@/models/base.filter';

export default {
  name: 'filter-form',
  extends: BaseFilter,
  props: {
    name: String,
    organizationId: String,
    email: String,
    isDeleted: [String, Boolean],
    isUser: [String, Boolean]
  },
  data() {
    return {
      form: {
        name: this.name || '',
        organizationId: this.organizationId || '',
        email: this.email || '',
        isDeleted: this.isDeleted == 'true' || false,
        isUser: this.isUser == 'true' || false,
      },
      organizations: [],
    };
  },
  created() {
    this.addEventListener();
    this.loadOrganizations();
  },
  methods: {
    changeIsDeleted() {
      this.form.isDeleted = !this.form.isDeleted;
      this.search();
    },
    changeIsUser() {
      this.form.isUser = !this.form.isUser;
      this.search();
    },
    reset: function(e) {
      e.stopPropagation();
      this.$emit('reset');
      this.form = {
        name: '',
        email: '',
        isDeleted: false,
        isUser: true,
      };
      this.form.organizationId = this.$auth.user().impersonateOrganizationId || this.$auth.user().organizationId;

      this.search();
    },
    loadOrganizations() {
      axios
        .get('/Dictionary/GetOrganizations')
        .then((response) => {
          this.organizations = response.data;
        })
        .catch(() => {});
    },
  },
};
</script>
